import ReactDOM from "react-dom";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import "bootstrap/scss/bootstrap.scss";
import "assets/scss/paper-kit.scss?v=1.3.0";
import "assets/demo/demo.css?v=1.3.0";
import "assets/css/issuer-system.css";

import App from "App";
import { store, persister } from './store';
import { initBaseManager } from "managers/baseManager";
import apiSetupManager from "managers/apiSetupManager";
import staticDataManager from "managers/staticDataManager";

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persister}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// initBaseManager MUST be first — apiSetupManager's interceptors call
// logoutAndPurge / getState which require the store reference to be set.
initBaseManager(store);
apiSetupManager(store);
staticDataManager(store);
